export const APP_LAUNCHER_LABELS = {
  title: 'Mis aplicaciones',
  close: 'Cerrar Mis aplicaciones',
  loading: 'Cargando aplicaciones…',
  emptyGroups: 'No hay empresas vinculadas a esta persona.',
  emptyGroup: 'No hay aplicaciones otorgadas.',
  groupCaption: 'Aplicaciones disponibles',
  tenantSelector: 'Tenant',
  refresh: 'Actualizar aplicaciones',
  retry: 'Reintentar',
  pending: 'Abriendo...',
  disabledFallback: 'Aplicación no disponible.',
  catalogError: 'No pudimos cargar las aplicaciones.',
  viewAll: 'Ver todas',
}
